<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Dasher Coin Balance Report</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
      ></v-text-field>
    </v-toolbar>

    <div v-if="indexData.total < 1" class="text-xs-center">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <v-data-table
      :headers="headers"
      :items="indexData.dasherCoinBalanceDetails"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td>{{ props.item.user_id }}</td>
        <td>
          {{ props.item.first_name }} {{ props.item.middle_name }}
          {{ props.item.last_name }}
        </td>
        <td>{{ props.item.transaction_id }}</td>
        <td>{{ props.item.transaction_date }}</td>
        <td>{{ props.item.id }}</td>
        <td>{{ props.item.wallet_type }}</td>
        <td>{{ props.item.wallet_type }}</td>
        <td>N/A</td>
        <td>
          {{
            getCoinsBeforeTransaction(
              props.item.remaining_coin,
              props.item.amount_coin
            )
          }}
        </td>
        <td>
          {{
            getTakaBeforeTransaction(
              props.item.remaining_amount,
              props.item.withdraw_amount
            )
          }}
        </td>
        <td>{{ props.item.amount_coin }}</td>
        <td>{{ props.item.withdraw_amount }}</td>
        <td>{{ props.item.remaining_coin }}</td>
        <td>{{ props.item.remaining_amount }}</td>
      </template>
    </v-data-table>
    <v-spacer></v-spacer>
    <v-btn class="button" color="info" flat @click="download">Download</v-btn>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import router from "../../../router";

export default {
  data: () => ({
    apiUrl: "dasher-cash-out-report",
    editedIndex: -1,
    dialog: false,
    search: "",
    projectId: "",
    transaction_status_id: "",
    paymentPercentage: "",
    projectStatus: {
      status_name: null,
      status_id: null,
    },
    paymentStatus: {
      payment_status_name: null,
      payment_status_id: null,
    },
    projectTypeId: null,
    headers: [
      { text: "Dasher ID", value: "user_id" },
      { text: "Dasher Name", value: "first_name" },
      { text: "Transaction ID", value: "transaction_id" },
      { text: "Transaction Date", value: "transaction_date" },
      { text: "Cash Out Request ID", value: "id" },
      { text: "Cash Out Details", value: "wallet_type" },
      { text: "Reference", value: "wallet_type" },
      { text: "Team Code", value: "id" },
      { text: "Coin Earnings before transaction", value: "amount_coin" },
      { text: "Taka Earnings before transaction", value: "withdraw_amount" },
      { text: "Coins Cash Out", value: "amount_coin" },
      { text: "Taka Cash Out", value: "withdraw_amount" },
      { text: "Coin Balance after transaction", value: "remaining_coin" },
      { text: "Taka Balance after transaction", value: "remaining_amount" },
    ],
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "errorMsg",
    ]),
    isLoaded() {
      if (this.indexData.dasherCoinBalanceDetails) {
        return true;
      } else {
        return false;
      }
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      //  console.log(user_id);
      this.$store.dispatch("setIndexData", ["dasher-coin-balance-report"]);
    },

    setErrorZero() {
      this.$store.dispatch("setErrorZero");
    },
    getTaka: function (coins) {
      return coins / 10;
    },
    getTakaBeforeTransaction: function (balance, withdraw) {
      return balance + withdraw;
    },
    getCoinsBeforeTransaction: function (balance, withdraw) {
      return balance + withdraw;
    },
    close() {
      setTimeout(() => {
        this.budget = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    download() {
      // window.open(
      //   `http://local.ddbb.com/coin-balance-report-export`
      // );
      window.open(this.indexData.excelUrl);
    },
    back() {
      router.push("/dasher-summary-report");
    },
  },
};
</script>

<style scoped>
.icon {
  background: #ff2e2e;
  color: aliceblue;
  cursor: pointer;
  border-radius: none;
  margin: 10px;
}
.delete {
  color: #3f51b5;
  cursor: pointer;
}
span {
  width: 20px;
  cursor: pointer;
}
.no-upercase {
  text-transform: unset !important;
}
.text_color {
  color: white;
}
.project {
  background: #ff2e2e;
}
::v-deep ::-webkit-scrollbar {
  width: 0;
}
</style>
